var chunkToChildrenMap = {
	"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-7f062f1": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_measurement-tracking_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTag-2159fb": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-sr_src_components_OHIFCornerstoneSRViewport_tsx",
		"extensions_measurement-tracking_src_viewports_TrackedCornerstoneViewport_tsx"
	],
	"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-7f062f2": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-sr_src_components_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_cornerstone-dicom-seg_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTa-21e288": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-seg_src_viewports_OHIFCornerstoneSEGViewport_tsx"
	],
	"extensions_cornerstone-dicom-pmap_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomT-5177de": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-pmap_src_viewports_OHIFCornerstonePMAPViewport_tsx"
	],
	"extensions_cornerstone-dynamic-volume_src_index_ts-extensions_default_src_DicomTagBrowser_Dic-015d6e": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_dicom-pdf_src_index_tsx": [
		"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx"
	],
	"extensions_dicom-video_src_index_tsx": [
		"extensions_dicom-video_src_viewports_OHIFCornerstoneVideoViewport_tsx"
	],
	"extensions_tmtv_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-exte-0947ba": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_test-extension_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTagBrowse-9c49f0": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-rt_src_index_tsx": [
		"vendors-node_modules_cornerstonejs_calculate-suv_dist_calculate-suv_esm_js-node_modules_brows-f8a8b3",
		"vendors-node_modules_cornerstonejs_ai_dist_esm_index_js-node_modules_cornerstonejs_core_dist_-1038f6",
		"extensions_default_src_index_ts",
		"extensions_cornerstone_src_components_NavigationComponent_NavigationComponent_tsx-extensions_-cc794b",
		"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx-extensions_defaul-234efa"
	],
	"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx-extensions_defaul-234efa": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));